function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Button } from 'swag-client-common/components/ui/button';
import { connect } from 'react-redux';
import { MAX_ITEM_ATTACHMENT_FILE_SIZE } from 'swag-client-common/utils/constants';
import { designNotesDispatcher } from '../../../../../redux/product/product.dispatchers';
import { designNotesEditorSelector } from '../../../../../redux/product/product.selectors';
import classes from './design-notes.scss';
import DesignAttachments from './components/design-attachments';
class DesignNotes extends React.Component {
  constructor(props, context) {
    super(props, context);
    _defineProperty(this, "textAreaElement", void 0);
    const {
      attachments,
      notes
    } = props;
    this.state = {
      notes,
      attachments,
      error: null
    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onFileAdd = this.onFileAdd.bind(this);
    this.onFileDelete = this.onFileDelete.bind(this);
  }
  componentDidMount() {
    this.textAreaElement.focus();
  }
  onChange(e) {
    this.setState({
      notes: e.target.value
    });
  }
  onFileAdd(file) {
    if (file.size > MAX_ITEM_ATTACHMENT_FILE_SIZE) {
      this.setState({
        error: 'The file is too large'
      });
    } else {
      const attachments = [...this.state.attachments];
      attachments.push(file);
      this.setState({
        attachments,
        error: null
      });
    }
  }
  onFileDelete(index, key) {
    const {
      onDeleteAttachment
    } = this.props;
    const attachments = [...this.state.attachments];
    attachments.splice(index, 1);
    if (key) {
      onDeleteAttachment(key);
    }
    this.setState({
      attachments
    });
  }
  onSubmit() {
    const {
      onSubmit
    } = this.props;
    const {
      notes,
      attachments
    } = this.state;
    onSubmit({
      notes,
      attachments
    });
  }
  render() {
    const {
      notes,
      attachments,
      error
    } = this.state;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("textarea", {
      placeholder: "Please, enter your design note here",
      className: classes.textArea,
      rows: 2,
      name: "designNote",
      maxLength: 500,
      value: notes,
      onChange: this.onChange,
      ref: el => {
        // @todo. auto generated. fix this error
        // @ts-ignore
        this.textAreaElement = el;
      }
    }), /*#__PURE__*/React.createElement(DesignAttachments, {
      attachments: attachments,
      onFileAdd: this.onFileAdd,
      onFileDelete: this.onFileDelete
    }), error && /*#__PURE__*/React.createElement("span", {
      className: classes.errorMessage
    }, error), /*#__PURE__*/React.createElement(Button, {
      onClick: this.onSubmit,
      className: classes.button,
      type: "primary",
      size: "small"
    }, "Save"));
  }
}
export default connect(designNotesEditorSelector, designNotesDispatcher)(DesignNotes);